import { render, staticRenderFns } from "./setting-billing-model-list.vue?vue&type=template&id=06e38a57&scoped=true&"
import script from "./setting-billing-model-list.vue?vue&type=script&lang=js&"
export * from "./setting-billing-model-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e38a57",
  null
  
)

export default component.exports